// @ts-ignore
const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT
if (!API_ENDPOINT) {throw new Error("missing API_ENDPOINT")}

export class HttpService {
  public headers: Headers

  constructor() {
    this.headers = new Headers()
    this.headers.append('Content-Type', 'application/json')
  }

  public async query(path: string, request: RequestInit): Promise<any> {
    try {
      return await fetch(API_ENDPOINT + path, {
        method: request.method, body: request.body, headers: this.headers
      })
    }
    catch (error) {
      return error as Error
    }
  }

  setAuth(jwt:string) {
    this.headers.set('Authorization', `Bearer ${jwt}` )
  }

  clearAuth() {
    this.headers.delete('Authorization')
  }

}

export const httpService = new HttpService()